import React, { useRef, useState, useLayoutEffect } from 'react';
import styled from 'styled-components';

function ScalableText({ wrapperStyle = null, text, textStyle = null, onClick = () => null, minScale = 0.5 }) {
  const containerRef = useRef(null);
  const textRef = useRef(null);
  const [scale, setScale] = useState(1);

  useLayoutEffect(() => {
    const resize = () => {
      if (!containerRef.current || !textRef.current) return;

      const containerWidth = containerRef.current.offsetWidth;
      const textWidth = textRef.current.scrollWidth;

      let nextScale = containerWidth / textWidth;
      nextScale = Math.min(1, Math.max(minScale, nextScale));
      setScale(nextScale);
    };

    resize();

    const observer = new ResizeObserver(resize);
    observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, [text]);

  return (
    <Wrapper ref={containerRef} $wrapperStyle={wrapperStyle} onClick={onClick}>
      <ScaledInner style={{ transform: `translate(-50%, -50%) scale(${scale})` }}>
        <Content ref={textRef} $textStyle={textStyle}>
          {text}
        </Content>
      </ScaledInner>
    </Wrapper>
  );
}

export default ScalableText;

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 2.5rem;
  overflow: visible;
  ${({ $wrapperStyle }) => $wrapperStyle}
`;

const ScaledInner = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform-origin: center;
  white-space: nowrap;
`;

const Content = styled.div`
  white-space: nowrap;
  font-size: 1.2rem;
  font-weight: 700;
  color: white;
  text-align: center;
  ${({ $textStyle }) => $textStyle}
`;

